import { useMemo } from 'react';
import ReactPlayer from 'react-player';

export const Player = ({ url, videoId, ...props }) => {
  const config = useMemo(
    () => ({
      youtube: {
        playerVars: {
          showinfo: false
        },
        embedOptions: {
          videoId
        }
      },
      vimeo: {
        playerOptions: {
          title: false,
          sidedock: false
        }
      },
      file: {
        forceVideo: true
      }
    }),
    [videoId]
  );

  return (
    <ReactPlayer
      key={url}
      url={url}
      config={config}
      controls={false}
      volume={0.5}
      height="100%"
      width="100%"
      muted={false}
      loop
      playsinline
      {...props}
    />
  );
};
